import React, { useState, useEffect } from 'react';
import i18n from 'i18n-js';
import { statuses } from 'constants/payments';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError, generateFilterOptions } from 'utils';

const PaymentStatusSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
  omitFields = [],
  asyncErrors,
  margin,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [defaultValue, setDefaultValue] = useState('');
  const filterOptions = generateFilterOptions('start', 'label');
  useEffect(() => {
    if (value || value === '') {
      const defaultVal = statuses.find((status) => status === value);
      if (defaultVal) {
        setDefaultValue(i18n.t(`payment_statuses.${defaultVal}`));
      } else {
        setDefaultValue('');
      }
    }
  }, [value, statuses]); // eslint-disable-line

  return (
    <Autocomplete
      openOnFocus
      label={label}
      margin={margin}
      variant={variant}
      id="payment-statuses"
      inputValue={inputValue}
      defaultValue={defaultValue}
      filterOptions={filterOptions}
      onInputChange={(ev, val) => setInputValue(val || '')}
      onChange={(ev, val) => setFieldValue(name, val || '')}
      error={handleError(name, errors, touched, asyncErrors)}
      getOptionSelected={(option, value) => option === value || ''}
      options={statuses.filter((value) => omitFields.indexOf(value))}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
      getOptionLabel={(option) =>
        i18n.t(`payment_statuses.${option}`, { defaultValue: option?.label || option })
      }
    />
  );
};

export default PaymentStatusSelect;
